import React from 'react';

const PHIAuditEmptyState = () => {
  return (
    <div className="text-center py-5 px-3">
      <div
        className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
        style={{
          width: '64px',
          height: '64px',
          backgroundColor: '#f0f4ff',
        }}
      >
        <i
          className="wb webconnect-shield-check"
          style={{
            fontSize: '28px',
            color: '#4a6cf7',
          }}
        />
      </div>

      <h5 className="fw-semibold mb-2">PHI Audit Not Available</h5>

      <p
        className="text-muted mb-4 mx-auto"
        style={{
          maxWidth: '500px',
        }}
      >
        This project hasn't been audited for potential PHI exposure yet. Run an audit to check its
        collections, fields, public filters, and pages.
      </p>

      <div
        className="border rounded p-3 mx-auto text-left"
        style={{
          maxWidth: '520px',
          backgroundColor: '#fafbfc',
        }}
      >
        <div className="d-flex align-items-start mb-3">
          <i className="wb webconnect-search mr-3 mt-1 text-primary" />

          <div>
            <div className="fw-semibold">What will be checked?</div>

            <div className="text-muted small mt-1">
              Potential PHI in collection fields, public filters, and public pages.
            </div>
          </div>
        </div>

        <div className="d-flex align-items-start">
          <i className="wb webconnect-shield-check mr-3 mt-1 text-success" />

          <div>
            <div className="fw-semibold">Metadata-only analysis</div>

            <div className="text-muted small mt-1">
              The audit analyzes project metadata and does not inspect actual stored records.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PHIAuditEmptyState;
